import { produce } from "immer";

// Shared keys to delete from physical objects when processing project data
export const DELETE_KEYS = [
  "active",
  "color",
  "compressSize",
  "compressed",
  "description",
  "md5",
  "priority",
  "supplier",
  "thumbnailSize",
  "uncompressedSize",
  "visible",
  "updatedAt",
];

export const processProjectData = (projectData: any) => {
  const objects = [];

  // Process physical objects
  if (projectData.physicalObjects) {
    projectData.physicalObjects.forEach((obj: any) => {
      const nextObj = produce(obj, (draft: any) => {
        DELETE_KEYS.forEach((k) => {
          delete draft[k];
        });
      });
      objects.push(nextObj);
    });
  }

  // Process background texture
  let backgroundTexture = projectData.backgroundTexture;
  if (projectData.backgroundTexture) {
    backgroundTexture = projectData.backgroundTexture?.materialData
      ?.materialProps
      ? projectData.backgroundTexture
      : produce(projectData.backgroundTexture, (draft: any) => {
          draft.materialData = {
            files: projectData.backgroundTexture.files,
            materialProps: projectData.backgroundTexture.materialProps,
            name: projectData.backgroundTexture.name,
            id: projectData.backgroundTexture.id,
          };
        });
  }

  return {
    objects,
    backgroundTexture,
    lighting: projectData.lighting,
    cameraPosition: projectData.cameraPosition,
    controlsTarget: projectData.controlsTarget,
    screenshot: projectData.files?.screenshot,
    projectData: projectData.projectData || {},
  };
};
